import { render, staticRenderFns } from "./Kaggler.vue?vue&type=template&id=2dd33cf1&scoped=true"
import script from "./Kaggler.vue?vue&type=script&lang=ts"
export * from "./Kaggler.vue?vue&type=script&lang=ts"
import style0 from "./Kaggler.vue?vue&type=style&index=0&id=2dd33cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd33cf1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnDirection: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-direction.vue').default})
